import { getFragmentData } from "@/__generated__";
import type { VisitQuery, VisitQueryVariables } from "@/__generated__/graphql";
import { VisitClientFragmentFragmentDoc, VisitDocument } from "@/__generated__/graphql";
import type { VisitDetailData } from "@/components/shared/visits/visit-detail";
import { mapToVisitDetailData } from "@/components/shared/visits/visit-detail";
import { createRequestFactory } from "@/lib/request-factory";

export const useVisitStore = createRequestFactory<VisitQuery, VisitDetailData, VisitQueryVariables>(
  {
    method: "query",
    graphqlDocument: VisitDocument,
    fetchPolicy: "network-only",
    transformFunction(data) {
      const visit = getFragmentData(VisitClientFragmentFragmentDoc, data.visit);
      return mapToVisitDetailData(visit);
    },
  },
);
